/**
 * Преобразования BoolInt в Boolean
 * @param {Number} boolInt
 * @return {Boolean}
 */
export var numberToBool = function numberToBool(number) {
  return number === 1;
};